import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output} from '@angular/core';
import {PageNames} from '../../../shared/page-names.enum';
import {NavigationService} from '../../../services/navigation/navigation.service';
import {ModalConfig} from '../../../model/modal-config';
import {Order} from '../../../model/order';
import {ResourceService} from '../../../services/resource/resource.service';
import {OmapiIdConstants} from '../../../shared/omapi-id-constants';
import {QrCodeTypeEnum} from '../../../enums/streaming-bundles/qr-code-type.enum';
import {TvShopStateService} from '../../../services/state/tv-shop-state.service';
import {TvShopEntertainmentPack} from '../../../model/tv-shop-entertainment-pack';
import {OmapiIdsUtils} from '../../../shared/utils/omapi-ids/omapi-ids-utils';


@Component({
  selector: 'app-order-completed',
  templateUrl: './order-succeeded.component.html',
  styleUrls: ['./order-succeeded.component.less']
})

export class OrderSucceededComponent implements AfterViewInit {
  @Input() order: Order;
  @Input() config: ModalConfig;
  @Input() descriptionKey;
  componentName = PageNames.ORDERING_SUCCEEDED;
  @Input() titleKey: string;
  @Input() closeButtonTextKey: string;
  @Output()
  emitCloseOrderSucceeded = new EventEmitter<Object>();
  @Output()
  emitOnBack = new EventEmitter<Object>();

  pack: TvShopEntertainmentPack;
  isSubscribedStreamingPack = false;
  logoUrl: string;
  qrCodeType: QrCodeTypeEnum;
  qrTitle: string;
  qrDescription: string;

  constructor(protected navigationService: NavigationService,
              private changeDetector: ChangeDetectorRef,
              private resourceService: ResourceService,
              private stateService: TvShopStateService
  ) {
    this.pack = this.stateService.selectSnapshot(state => state.basket.selectedTvShopEntertainmentPack);
    this.setSubscribedStreamingPackState();
  }

  ngAfterViewInit(): void {
    this.navigationService.resetNavigation();
    this.setLogoUrl();
  }

  private setLogoUrl() {
    if (this.order.type === Order.DAYPASS) {
      this.logoUrl = this.resourceService.getLogoUrl(OmapiIdConstants.PLAY_SPORTS, undefined, false);
    } else {
      this.logoUrl = this.resourceService.getLogoUrl(this.order.packOmapiId, this.order.subPackOmapiId, false);
    }
    this.changeDetector.detectChanges();
  }

  public onEmitCloseOrderSucceeded(): void {
    this.emitCloseOrderSucceeded.emit({
      omapiId: this.order.packOmapiId
    });
  }

  onBack(): void {
    this.emitOnBack.emit({
      value: true
    });
  }

  getPackageName() {
    return this.order.packOmapiId === OmapiIdConstants.RED_CARPET_MORE ? OmapiIdConstants.COM_NAME_RED_CARPET_MORE : this.order.orderName();
  }


  private setSubscribedStreamingPackState() {
    if (
      (this.pack.isStreamingBundle || this.pack.isStreamingStandaloneProduct || this.pack.isGroupPack) &&
      this.pack.subscribed) {
      this.isSubscribedStreamingPack = true;

      if (this.pack.omapiId === OmapiIdsUtils.DISNEY_PLUS_ID) {
        this.qrTitle = 'eos-tv-shop-ii.title.qr-tile-disney-plus';
        this.qrDescription = 'eos-tv-shop-ii.text.qr-tile-description-disney-plus';
        this.qrCodeType = QrCodeTypeEnum.ACTIVATE_DISNEY;
      } else {
        this.qrTitle = 'eos-tv-shop-ii.title.qr-tile-netflix';
        this.qrDescription = 'eos-tv-shop-ii.text.qr-tile-description-netflix';
        this.qrCodeType = QrCodeTypeEnum.ACTIVATE_NETFLIX;
      }
    }
  }

}
